import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { colors, getSpacing } from '../utils';

const Wrapper = styled.div`
  background-color: ${colors.b03};
  border-radius: 2px;
  margin: ${props => getSpacing(props.margin)};
  padding: ${props => getSpacing(props.padding)};
  text-align: center;
`;

const Topic = styled.div`
  color: #444;
  font-size: 20px;
  font-weight: bold;
`;

const Group = styled.div`
  font-family: 'Mada', 'Glyphicons Halflings', Arial, sans-serif;
  font-size: 16px;
  font-variant-ligatures: none;
  letter-spacing: 0;
  line-height: 1.42857;
`;

const MessageBox = props => {
  const { group, topic } = props;

  if (!group && !topic) {
    return null;
  }

  return (
    <Wrapper
      padding={{ top: 'small', bottom: 'small', left: 'small', right: 'small' }}
      margin={{ bottom: 'xs' }}
    >
      {group && <Group>{group}</Group>}
      {topic && <Topic>{topic}</Topic>}
    </Wrapper>
  );
};

MessageBox.defaultProps = {
  group: '',
  topic: ''
};

MessageBox.propTypes = {
  topic: PropTypes.string,
  group: PropTypes.string
};

export { MessageBox };
